import styled from 'styled-components'

const OrderBumpTitleUi = styled.div`
  display: flex;
  align-items: center;
  line-height: 20px;
`

export default OrderBumpTitleUi
